export default {
  year: 2025,
  edition: "제 21회",
  date: "2025년 11월 8일 토요일",
  time: "오후 2시 ~ 5시",
  location: "다산관 D104/D105",
  links: {
    problems: {
      BOJ: "https://www.acmicpc.net/category/1140",
    },
    solutions: {
      PDF: "/downloads/spc/2025/solutions.pdf",
    },
  },
  authors: ["이재찬", "김동건", "송근수", "김규민", "김태윤", "조원빈"],
  contests: [
    {
      title: "SPC 2025 Master",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "7", "양제웅"],
        ["2", "7", "노주환"],
        ["3", "7", "최용주"],
        ["4", "6", "박준우"],
        ["5", "5", "천우영"],
        ["6", "4", "도정민"],
      ],
      award: ["gold", "silver", "silver", "bronze", "bronze", "bronze"],
      links: [["스코어보드", "https://www.acmicpc.net/contest/spotboard/1591"]],
    },
    {
      title: "SPC 2025 Champion",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "7", "이재혁"],
        ["2", "6", "강효규"],
        ["3", "5", "오유준"],
        ["4", "4", "김진수"],
        ["5", "3", "이하윤"],
        ["6", "3", "전현길"],
        ["7", "3", "정우찬"],
      ],
      award: [
        "winner",
        "gold",
        "silver",
        "silver",
        "bronze",
        "bronze",
        "bronze",
      ],
      links: [["스코어보드", "https://www.acmicpc.net/contest/spotboard/1592"]],
    },
  ],
};
